module.exports = __webpack_public_path__ + "img/image-03.d3054c39.webp";